// extracted by mini-css-extract-plugin
export var numpadContainer = "_rz-1";
export var phoneButton = "_rz-0";